var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.oneCheck && _vm.oneCheck.data)?_c('check-profile',{attrs:{"can_show_actions":false}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }